<template>
    <Link
        v-if="type === 'Link'"
        :href="href"
        @click="$emit('click')"
        :class="[
            'w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all active:scale-[0.98]',
            variantClasses[variant]
        ]"
    >
        <span class="flex-shrink-0 opacity-90">
            <component :is="icon" class="w-4 h-4" />
        </span>
        <span class="flex-1 text-left">{{ label }}</span>
        <slot name="badge">
            <span
                v-if="badge"
                class="flex-shrink-0 px-2 py-0.5 rounded-md bg-white/10 text-white/70 text-[10px] font-bold uppercase tracking-wider"
            >
                {{ badge }}
            </span>
        </slot>
    </Link>
    <component
        v-else
        :is="type"
        :href="href"
        @click="$emit('click')"
        :class="[
            'w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all active:scale-[0.98]',
            variantClasses[variant]
        ]"
    >
        <span class="flex-shrink-0 opacity-90">
            <component :is="icon" class="w-4 h-4" />
        </span>
        <span class="flex-1 text-left">{{ label }}</span>
        <slot name="badge">
            <span
                v-if="badge"
                class="flex-shrink-0 px-2 py-0.5 rounded-md bg-white/10 text-white/70 text-[10px] font-bold uppercase tracking-wider"
            >
                {{ badge }}
            </span>
        </slot>
    </component>
</template>

<script setup>
import {Link} from "@inertiajs/vue3";

const props = defineProps({
    type: {
        type: String,
        default: 'button'
    },
    icon: {
        type: [Object, Function],
        required: true
    },
    label: {
        type: String,
        required: true
    },
    href: {
        type: String,
        default: undefined
    },
    variant: {
        type: String,
        default: 'default',
        validator: (value) => ['default', 'primary', 'danger'].includes(value)
    },
    badge: {
        type: String,
        default: undefined
    }
})

defineEmits(["click"])

const variantClasses = {
    default: 'text-white/80 hover:text-white hover:bg-white/5',
    primary: 'text-blue-400 hover:text-blue-300 hover:bg-blue-500/10',
    danger: 'text-red-400 hover:text-red-300 hover:bg-red-500/10'
}
</script>
